<div *ngIf="displayCard && enablePartnerOffersDynamicFlow; else displayOldView">
  <div *ngIf="!partnersInfoDefaultView; else defaultViewNew">
    <div
      class="partner-offer-item" [ngClass]="{'offer-claim-height': !partnersInfoDefaultView, 'default-height': partnersInfoDefaultView}">
      <div id="image-description" class="sr-only">{{ partnersOfferDisplay?.bgImgAltText }}</div>
      <div class="partners-offer-img" role="img"
        [attr.aria-labelledby]="'image-description'"></div>
      <div class="partners-offer-content">
        <div class="partners-card-title-container">
          <h3 class="partners-card-title">{{ partnersOfferDisplay?.title}}</h3>
        </div>
        <div class="partners-card-sub-title-container">
          <div class="partners-card-sub-title">{{ partnersOfferDisplay?.subTitle}}</div>
        </div>
        <div class="offer-btn-container">
          <div  *ngIf="partnersOfferDisplay?.isOfferRedeemed; else showClaimOffers">
            <span id="redeem-label" class="sr-only">Redeem offer for {{ partnersOfferDisplay?.title}}</span>
            <button class="offerClaimCTA" type="button" aria-labelledby="redeem-label"
            [ngClass]="{'isDisabled': (partnersOfferDisplay?.isOfferRedeemed)}">
            <img src="ocsp-web-ui/dist/assets/images/check-mark.png" class="fp-partner-offers-check-mark" aria-hidden="true">
            <span aria-hidden="true">{{'Redeemed'}}</span>
          </button>
          </div>
          <ng-template #showClaimOffers>
            <button class="offerClaimCTA" type="button"  (click)="onClickCTA($event)"
              (keydown.enter)="onClickCTA($event)" [ngClass]="{'isDisabled': (!partnersOfferDisplay?.enableCta)}">
              {{partnersOfferDisplay?.ctaText}}
          </button>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
  <ng-template #defaultViewNew>
    <div class="partner-offer-item" [ngClass]="{'offer-claim-height': enableClaimOfferCTA, 'default-height': !enableClaimOfferCTA}">
      <div id="image-description" class="sr-only">{{ partnersOfferDisplay?.bgImgAltText }}</div>
      <div class="partners-offer-img" role="img"
        [attr.aria-labelledby]="'image-description'"></div>
      <div class="partners-offer-content">
        <div class="partners-card-title-container">
          <h3 class="partners-card-title">{{ partnersOfferDisplay?.title}}</h3>
        </div>
        <div class="partners-card-sub-title-container">
          <div class="partners-card-sub-title">{{ partnersOfferDisplay?.subTitle}}</div>
        </div>
      </div>
    </div>
  </ng-template>
</div>
<ng-template #displayOldView>
<div *ngIf="!enablePartnerOffersDynamicFlow">
  <div *ngIf="enableClaimOfferCTA; else defaultViewOld">
    <a
      class="partner-offer-item" [ngClass]="{'offer-claim-height': enableClaimOfferCTA, 'default-height': !enableClaimOfferCTA}"
      role="link"
      tabindex="0"
      [attr.data-cta-link]="partnersOfferDisplay?.ctaLink"
      [attr.aria-label]="partnersOfferDisplay?.title + ', link, opens in new tab'"
      href="{{ partnersOfferDisplay?.ctaLink }}" target="_blank"
      (click)="onClickCTA($event)"
      (keydown.enter)="onClickCTA($event)"
      >
      <div id="image-description" class="sr-only">{{ partnersOfferDisplay?.bgImgAltText }}</div>
      <div class="partners-offer-img" role="img"
        [attr.aria-labelledby]="'image-description'"></div>
      <div class="partners-offer-content">
        <div class="partners-card-title-container">
          <h3 class="partners-card-title">{{ partnersOfferDisplay?.title}}</h3>
        </div>
        <div class="partners-card-sub-title-container">
          <div class="partners-card-sub-title">{{ partnersOfferDisplay?.subTitle}}</div>
        </div>
        <div class="offer-btn-container">
          <div class="offerClaimCTA">{{ partnersOfferDisplay?.ctaText }}</div>
        </div>
      </div>
    </a>
  </div>
  <ng-template #defaultViewOld>
    <div class="partner-offer-item" [ngClass]="{'offer-claim-height': enableClaimOfferCTA, 'default-height': !enableClaimOfferCTA}">
      <div id="image-description" class="sr-only">{{ partnersOfferDisplay?.bgImgAltText }}</div>
      <div class="partners-offer-img" role="img"
        [attr.aria-labelledby]="'image-description'"></div>
      <div class="partners-offer-content">
        <div class="partners-card-title-container">
          <h3 class="partners-card-title">{{ partnersOfferDisplay?.title}}</h3>
        </div>
        <div class="partners-card-sub-title-container">
          <div class="partners-card-sub-title">{{ partnersOfferDisplay?.subTitle}}</div>
        </div>
      </div>
    </div>
  </ng-template>
</div>
</ng-template>